import { graphql } from 'react-relay';

export const ModelGeneration3DModelsQuery = graphql`
    query modelGeneration3DModelsQuery {
        modelGeneration3DModels {
            serviceID
            serviceIDs
            model
            maxPromptLength
            supportedModes
            supportedParameters {
                name
                type
                supportedModes
                isRequired
                defaultValue
                allowedValues
                minValue
                maxValue
            }
        }
    }
`;
